import { BreakpointProps } from '@ux/responsive';
import { ImagesWithAspectRatios, ImageWithAspectRatios } from 'core/ribbons/primitives';
import { ImageAspectRatio } from 'domain/constants/imageAspectRatio';
import { Dimension } from 'domain/constants/dimension';
import findResponsiveItem from 'presentation/utils/findResponsiveItem';

/**
 * If imagesWithAspectRatios is present in ribbon props, this should be used.
 * This array follows the existing standard of [mobile,tablet,desktop] structure.
 * Where imagesWithAspectRatios is empty/omitted, the existing imageUrl and imageAspectRatio should be used.
 */

type ImageProps = {
  imageUrl?: string;
  imageAspectRatio?: ImageAspectRatio;
  preserveDimension?: Dimension | string;
};

export default (
  breakpoints: BreakpointProps,
  image: ImageProps,
  imagesWithAspectRatios: ImagesWithAspectRatios | undefined,
): ImageWithAspectRatios => {
  const { imageUrl: url, imageAspectRatio, preserveDimension } = image;

  if (imagesWithAspectRatios != null && imagesWithAspectRatios.length > 0) {
    const activeImageWithAspectRatios = findResponsiveItem(breakpoints, imagesWithAspectRatios);
    return activeImageWithAspectRatios || {};
  }

  return {
    url,
    imageAspectRatio,
    preserveDimension,
  };
};
